export enum KeyboardType {
  login = 'login',
  password = 'password',
  search = 'search',
}

export interface KeyboardMapKey {
  width: number;
  upper: string[];
  lower: string[];
}

export type KeyboardMap = KeyboardMapKey[][];

export type KeyboardLanguagesMap = {
  [language in string]: {
    name: string;
    [KeyboardType.login]: KeyboardMap;
    [KeyboardType.password]: KeyboardMap;
    [KeyboardType.search]?: KeyboardMap;
  };
};

export interface KeyboardKey {
  value: string;
  width: number;
  lower: string;
  upper: string;
  diacriticForValue?: string;
  diacritic: {
    lower: string[];
    upper: string[];
  };
}

export type Keyboard = KeyboardKey[][];
